// @flow

export type TableHeaderColumn = {
  name: string,
  width: ?string,
  label: ?string,
  sortable: boolean
}

const buildTableHeaderColumn = (
  name: string,
  width: ?string = null,
  label: ?string = null,
  sortable: boolean = true
): TableHeaderColumn => {
  return {
    name,
    width,
    label,
    sortable
  }
}

export {
  buildTableHeaderColumn
}



// WEBPACK FOOTER //
// ./src/types/table-header-column.js